import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Home } from "./features/home/Home";
import { TermsOfService } from "./features/legal/TermsOfService/TermsOfService";
import { PrivacyPolicy } from "./features/legal/PrivacyPolicy/PrivacyPolicy";

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/terms-of-service" element={<TermsOfService />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
